export default "__VITE_ASSET__Zs2boco1__"